// extracted by mini-css-extract-plugin
export var closeButton = "_mh-1";
export var closeX = "_mh-3";
export var container = "_mh-0";
export var image = "_mh-2";